import { render, staticRenderFns } from "./StockSerialDigital.vue?vue&type=template&id=0175a552&"
import script from "./StockSerialDigital.vue?vue&type=script&lang=js&"
export * from "./StockSerialDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports